import React, { useEffect, useState } from "react";
import { isoToString } from "../../utils/dateTool";
import { BUDGET_DESCRIPTION, TIMELINE_DESCRIPTION } from "../../data/projects";
import BudgetTable from "./BudgetTable";
import { HiOutlineCalendar, HiOutlineClock, HiOutlineCheckCircle } from "react-icons/hi";

const Timetable = ({
  timeline,
  budget_allocation,
  currencyToken,
  createdAt,
}) => {
  const isCompleted = (item) => {
    return Math.floor(new Date(item?.due_date).getTime() / 1000) + (item?.duration * (24 * 3600)) < Math.floor(new Date().getTime() / 1000);
  };

  return (
    <div className="w-full flex flex-col pt-6 roboto-font">
      {/* Timeline Section */}
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-primary to-[#7e7cff] flex items-center justify-center">
            <HiOutlineCalendar className="w-5 h-5 text-white" />
          </div>
          <h5 className="text-xl font-bold text-secondary">Project Timeline</h5>
        </div>
        <p className="text-gray-600 leading-relaxed mb-8 max-w-3xl">
          {TIMELINE_DESCRIPTION}
        </p>
        
        <div className="w-full max-w-4xl">
          {timeline?.map((item, index, arr) => {
            const completed = isCompleted(item);
            return (
              <div
                key={index + item?.name}
                className="relative flex"
              >
                {/* Timeline Line */}
                {index !== arr.length - 1 && (
                  <div className={`absolute left-[19px] top-12 bottom-0 w-0.5 ${completed ? 'bg-green-400' : 'bg-gray-200'}`}></div>
                )}
                
                {/* Timeline Dot */}
                <div className={`relative z-10 flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-lg ${
                  completed 
                    ? 'bg-gradient-to-r from-green-400 to-green-500' 
                    : 'bg-gradient-to-r from-primary to-[#7e7cff]'
                }`}>
                  {completed ? (
                    <HiOutlineCheckCircle className="w-5 h-5" />
                  ) : (
                    <span>{String(index + 1).padStart(2, '0')}</span>
                  )}
                </div>
                
                {/* Content Card */}
                <div className="flex-1 ml-5 mb-6">
                  <div className={`p-5 rounded-xl transition-all duration-300 hover:shadow-md ${
                    completed 
                      ? 'bg-green-50/80 shadow-sm' 
                      : 'bg-white shadow-sm hover:shadow-lg'
                  }`}>
                    <div className="flex items-start justify-between flex-wrap gap-2">
                      <h6 className="text-lg font-semibold text-secondary">{item.name}</h6>
                      {completed && (
                        <span className="px-3 py-1 rounded-full bg-green-100 text-green-600 text-xs font-medium">
                          Completed
                        </span>
                      )}
                    </div>
                    
                    {item?.detail && (
                      <p className="text-gray-600 mt-3 whitespace-pre-wrap leading-relaxed">
                        {item?.detail}
                      </p>
                    )}
                    
                    <div className="flex flex-wrap items-center gap-4 mt-4 pt-4">
                      <div className="flex items-center gap-2 text-sm">
                        <HiOutlineCalendar className="w-4 h-4 text-primary" />
                        <span className="text-gray-500">Start:</span>
                        <span className="font-medium text-secondary">{isoToString(item?.start_date)}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <HiOutlineCalendar className="w-4 h-4 text-primary" />
                        <span className="text-gray-500">Due:</span>
                        <span className="font-medium text-secondary">{isoToString(item?.due_date)}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <HiOutlineClock className="w-4 h-4 text-primary" />
                        <span className="text-gray-500">Duration:</span>
                        <span className="font-medium text-secondary">{item?.duration} days</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      {/* Budget Allocation Section */}
      <div className="pt-8 mt-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-primary to-[#7e7cff] flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <h5 className="text-xl font-bold text-secondary">Budget Allocation</h5>
        </div>
        <p className="text-gray-600 leading-relaxed mb-8 max-w-3xl">
          {BUDGET_DESCRIPTION}
        </p>
      
        {budget_allocation?.length && (
          <BudgetTable
            budget_allocation={budget_allocation}
            currencyToken={currencyToken}
          />
        )}
      </div>
    </div>
  );
};

export default Timetable;
